import $ from "jquery";

const searchBar = (el) => {
    const searchBar = $(el);
    const toggleSearchBar = $('.js-toggle-search');

    toggleSearchBar.on('click', (e) => {
        e.preventDefault();

        searchBar.slideToggle();

        $('body').toggleClass('js-toggle-search-bar');
        $('#searchInput').trigger('focus');

    });

}

export default searchBar;
